<template>
  <div>
    <v-container>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card class="maincard">
          <v-container>
            <v-row align="center">
              <v-col cols="12" xs="12" sm="8">
                <v-card-title>Roboterverwaltung</v-card-title>
              </v-col>
              <v-col cols="12" xs="12" sm="4" style="text-align: right">
                <v-btn to="/robots/edit" color="success">
                  <v-icon style="margin-right: 10px">mdi-plus</v-icon>
                  <span>Neuer Roboter</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

          <RobotList />
        </v-card>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import RobotList from "@/components/robots/RobotList.vue";

export default {
  name: "RobotMgmt",
  components: { RobotList },
  data: () => ({}),
  methods: {}
};
</script>

<style scoped></style>
